import type { SxProps, Theme } from '@mui/material';

export const handbookMenuSx: SxProps<Theme> = {
  flexDirection: 'column',
  width: '100%',
  flex: '0 0 auto',
  border: 'none',
  listStyle: 'none',
  '@media (max-width: 767.98px)': {
    padding: 0,
  },
  '@media (max-width: 991.98px)': {
    marginBottom: '30px',
  },
  '& .sticky-menu': {
    marginTop: '90px',
    marginBottom: '-75px',
  },
  '& a': {
    display: 'block',
    lineHeight: '19px',
    position: 'relative',
    border: 'none',
    borderRadius: 0,
    backgroundColor: 'transparent',
    width: '100%',
    textAlign: 'left',
    outline: 'none',
    padding: '3px 0 !important',
    color: 'text.primary',
    '&.active, &.active:hover, &.active:focus': {
      color: 'primary.main',
      textDecoration: 'none',
    },
    '&:hover': {
      color: 'text.primary',
      textDecoration: 'underline',
    },
  },
  '& ul': {
    listStyle: 'revert',
    width: '100%',
    paddingLeft: '0 !important',
    marginBottom: '0 !important',
    '&:first-child': {
      padding: '10px 7px 10px 30px !important',
    },
    '&.first-list': {
      paddingLeft: '20px !important',
    },
    '& li': {
      marginLeft: '20px',
    },
  },
  '& .nav-item': {
    marginLeft: '0 !important',
  },
};

export const handbookMenuScrollSx: SxProps<Theme> = {
  margin: 0,
  padding: '5px 15px',
  width: '100%',
  overflow: 'auto',
  '@media (min-width: 768px)': {
    display: 'block',
    justifyContent: 'space-between',
  },
  '@media (min-width: 992px)': {
    width: '285px',
    borderRight: '1px solid',
    borderColor: 'border.default',
    marginRight: '20px',
    padding: '8px 5px 8px 0',
    maxHeight: 'calc(100vh - 104px)',
  },
  '@media (max-width: 991px)': {
    borderBottom: '1px solid',
    borderColor: 'border.default',
    paddingBottom: '35px',
  },
};

export const handbookTabsSx: SxProps<Theme> = {
  display: 'block',
  margin: 0,
  padding: '5px 15px',
  width: '100%',
  '@media (max-width: 575.98px)': {
    padding: 0,
  },
  '@media (max-width: 767.98px)': {
    overflowX: 'auto',
  },
  '@media (min-width: 768px)': {
    justifyContent: 'space-between',
  },
  '@media (min-width: 992px)': {
    padding: 0,
    paddingRight: '20px',
  },
  '& h1': {
    display: 'none',
  },
  '& h2': {
    fontSize: '19px',
    marginTop: '20px',
    fontWeight: 400,
    color: 'brand',
    '&:nth-child(2)': {
      marginTop: 0,
    },
  },
};
